export const environment = {
  production: false,
  ApiAppUrl: 'https://fcmgyapidev.clavisco.com/',
  ApiUIUrl: 'https://fcmgydev.clavisco.com/',
  env: 'Development',
  recatchaSiteKey: '6LeAroIrAAAAAP1WO6xyw3D8AqHH27qjp82sRjo6',
  LogRocketId: ''
};
